import type {IncomePropsType} from 'types/general';
import {getIsUserSubscribed} from 'general/libs/getIsUserSubscribed';

import {getPlatformComponent} from './getPlatformComponent';
import {getCartItemsCount} from './getCartItemsCount';

const loadPopup = async (target: Element, popupProps: IncomePropsType) => {
    const [, cartItemsCount] = await Promise.all([
        getIsUserSubscribed(popupProps.instance),
        getCartItemsCount(popupProps.instance),
    ]);

    const props = {
        ...popupProps,
        extraProps: {...popupProps.extraProps, cartItemsCount},
    };

    const PlatformComponent = await getPlatformComponent(props);

    return new PlatformComponent({
        target,
        props,
    });
};

export default loadPopup;
